import React, { FC } from 'react'
import { Wrapper } from './Wrapper'
import { FormType } from '..'
import { UseFormSetValue } from 'react-hook-form'

type Props = {
  disabled: boolean
  setValue: UseFormSetValue<FormType>
  inputRef: React.MutableRefObject<HTMLTextAreaElement | undefined>
}

const CannedResponse: FC<Props> = ({ setValue, inputRef, disabled }) => {
  return (
    <Wrapper
      tabIndex={-1}
      aria-hidden={true}
      onClick={() => {
        setValue('content', '/')
        inputRef.current?.focus()
      }}
      tip={intl.formatMessage({
        id: 'chat / input / canned response',
      })}
      disabled={disabled}
    >
      <span className="far fa-message-heart" />
    </Wrapper>
  )
}

export default CannedResponse
